import type { DateTimeFormatFuncProps } from './types';

export const formatTime = ({ locale, date }: DateTimeFormatFuncProps) =>
  new Intl.DateTimeFormat(locale, {
    hour: 'numeric',
    minute: 'numeric'
  }).format(date);
